const ACTIVE = 'ACTIVE'
const INACTIVE = 'INACTIVE'

export default {
  ACTIVE,
  INACTIVE,
}